import { render, staticRenderFns } from "./SignIn.vue?vue&type=template&id=04dff3bb&scoped=true&"
import script from "./SignIn.vue?vue&type=script&lang=js&"
export * from "./SignIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dff3bb",
  null
  
)

export default component.exports